import setFullbanner from './home/fullbanner';
import setProductSlider from './home/product_slider';
import setCarousel from '../components/carousel';
import setGridTopoSwiper from './home/gridTopo';
import setIcons from './home/icons';

//addImports

const Home = {
  init: function () {
    setFullbanner()
    setGridTopoSwiper();
		setCarousel();
    setIcons();

    if (window.innerWidth < 768) { setProductSlider();}
		
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init()
})
